import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header'; // Assuming Header is in src/components
import Footer from './components/Footer'; // Assuming you have a Footer component
import HomePage from './pages/HomePage'; // Create this in the next step
import ScriptsPage from './pages/ScriptsPage';
import DocsPage from './pages/DocsPage';
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBSjj3-nhGwklZkj87b6f_ioJGqL_gj9JI",
  authDomain: "devcore-f4d47.firebaseapp.com",
  projectId: "devcore-f4d47",
  storageBucket: "devcore-f4d47.firebasestorage.app",
  messagingSenderId: "830928828422",
  appId: "1:830928828422:web:c98d9b66cb7a6dc0b7ab87",
  measurementId: "G-SKXNGMQEC9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

function App() {
  return (
    <Router>
      <div className="min-h-screen flex flex-col">
        <Header /> {/* Header will always be visible */}
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/scripts" element={<ScriptsPage />} />
            <Route path="/docs" element={<DocsPage />} />
            {/* Add more routes here if needed */}
          </Routes>
        </main>
        <Footer /> {/* Footer will always be visible */}
      </div>
    </Router>
  );
}

export default App;